var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { id: "marketing-address-disclaimer" },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", [
              _c("h5", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "lists.marketingAddressDisclaimer.contactInformation"
                      )
                    ) +
                    "\n      "
                ),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "lists.marketingAddressDisclaimer.emailsYouSendThroughThePlatform"
                    )
                  ) +
                  "\n      " +
                  _vm._s(
                    _vm.$t("lists.marketingAddressDisclaimer.complyWith")
                  ) +
                  "\n      "
              ),
              _c("span", { staticClass: "bold" }, [
                _vm._v(
                  _vm._s(_vm.$t("lists.marketingAddressDisclaimer.caslLaws"))
                ),
              ]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("lists.marketingAddressDisclaimer.weRequire")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("lists.marketingAddressDisclaimer.theAddressMustBe")
                  ) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }